import { parseExpression } from '../motor/ast'

export function validarSintaxis(tag) {
  const contenido = tag.replace(/^\$\{|\}$/g, '').trim()
  const matchImagenConMedidas = contenido.match(/^(.*),\s*(\d+(?:\.\d+)?x\d+(?:\.\d+)?)\s*$/i)

  // No puede estar vacío
  if (!contenido) return { ok: false, error: 'Placeholder vacío' }

  // Permitir paréntesis envolventes
  if (contenido.startsWith('(') && contenido.endsWith(')')) {
    const inner = contenido.slice(1, -1).trim()
    if (!inner) return { ok: false, error: 'Placeholder vacío' }
    return validarSintaxis(`\$\{${inner}\}`)
  }

  // v: e i:
  if (/^(v:|i:)/.test(contenido)) return { ok: true }

  // alias/ruta de imagen con medidas
  if (matchImagenConMedidas) {
    const base = (matchImagenConMedidas[1] || '').trim()
    if (!base) return { ok: false, error: 'Placeholder vacío' }
    return { ok: true }
  }

  // función estilo imprimePosicion:alias,arg
  if (/^[a-zA-Z0-9_]+:/.test(contenido)) {
    const errors = []
    parseExpression(contenido, errors)
    const nested = errors.find((e) => e.code === 'nested_func_needs_parens')
    if (nested) return { ok: false, error: nested.message }
    return { ok: true }
  }

  // alias simple (variable o expresión)
  if (/^[a-zA-Z0-9_]+$/.test(contenido)) return { ok: true }

  return { ok: false, error: 'Sintaxis desconocida' }
}
